import {useQuery} from "@apollo/client";
import classnames from "classnames";
import {useEffect, useState} from "react";

import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {GQL_PS_REPORT_DATA, PSReportDataResponse} from "@/lib/queries/pagespeed.ts";
import {PageSpeedStep} from "@/pages/pagespeed/PageSpeedStep.tsx";
import {PSErrorState} from "@/pages/pagespeed/report/PSErrorState.tsx";
import {PagespeedReport} from "@/pages/pagespeed/types.ts";

interface PageSpeedDetailsContentProps {
  id: number;
}
export const PageSpeedDetailsContent = ({id}: PageSpeedDetailsContentProps) => {
  // ger report_id from url param and parse it to int
  const resultIdParam = new URLSearchParams(window.location.search).get("result_id");
  const resultId = resultIdParam ? parseInt(resultIdParam) : null;

  const [report, setReport] = useState<PagespeedReport | null>(null);
  const {data, loading, error} = useQuery<PSReportDataResponse>(GQL_PS_REPORT_DATA, {
    variables: {id, resultId},
    context: {
      noToast: true,
    },
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (!report && data?.psReportData?.data_url) {
      fetch(data?.psReportData.data_url)
        .then((response) => response.json())
        .then((data) => setReport(data))
        .catch((error) => console.log(error.message));
    }
  }, [report, data?.psReportData?.data_url]);

  if (error) {
    return <PSErrorState error={error.message} />;
  }
  if (loading) {
    return <LoadingContainer text="Loading report data..." />;
  }
  if (!data?.psReportData?.result_id) {
    return <div className="p-5 text-center">Report is not available yet. Please check back later.</div>;
  }
  if (!data?.service || !data?.psReportData) {
    return <div className="p-5 text-center">Service not available anymore</div>;
  }
  if (!report) {
    return <LoadingContainer text="Loading report data..." />;
  }

  const steps = [];
  if (report.pagespeed.steps.length === 1) {
    const step = report.pagespeed.steps[0];
    steps.push(
      <PageSpeedStep
        checkID={id}
        key={"one-step"}
        lhr={step.lhr}
        monitoringServer={data.psReportData.monitoring_server}
        checkName={data.service.name}
        mspChoices={data.mspChoices}
        options={report.options}
        performanceGrade={report.pagespeed.uptimecom.uptime_grade}
        networkSteps={report.network}
      />
    );
  } else {
    for (let i = 0; i < report.pagespeed.steps.length; i++) {
      steps.push(
        <div key={`card${i}`} className="card">
          <div key={`step${i}_hdr`} className="card-header">
            <button
              className={classnames("btn btn-link text-decoration-none", {collapsed: i > 0})}
              data-bs-toggle="collapse"
              data-bs-target={`#step${i}`}
            >
              {report.pagespeed.steps[i].name}
            </button>
          </div>
          <div
            key={`step${i}`}
            id={`step${i}`}
            className={classnames("collapse", {show: i == 0})}
            data-bs-parent="#steps"
          >
            <div className="card-body">
              <PageSpeedStep
                checkID={id}
                key={"one-step"}
                lhr={report.pagespeed.steps[i].lhr}
                monitoringServer={data.psReportData.monitoring_server}
                checkName={data.service.name}
                mspChoices={data.mspChoices}
                options={report.options}
                performanceGrade={report.pagespeed.uptimecom.uptime_grade}
                networkSteps={report.network}
              />
            </div>
          </div>
        </div>
      );
    }
  }
  return (
    <div className="pagespeed-report p-3 mt-4">
      <div className="pagespeed-steps">{steps}</div>
    </div>
  );
};
